// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  releaseId: __t.u64().primaryKey().name("release_id"),
  projectId: __t.u64().name("project_id"),
  buildId: __t.u64().name("build_id"),
  version: __t.u32(),
  channel: __t.string(),
  monetized: __t.bool(),
  priceSov: __t.i64().name("price_sov"),
  passId: __t.u64().name("pass_id"),
  publishedAt: __t.timestamp().name("published_at"),
  publishedBy: __t.identity().name("published_by"),
});
